import Base from './base'
import store from '@/store'
import router from '@/router';
/**
 * 通知类消息
 */
class Notify extends Base {
	/**
	 * @var resource 资源
	 */
	resource

	/**
	 * 初始化构造方法
	 *
	 * @param {Object} resource Socket消息
	 */
	constructor(resource) {
		super()

		this.resource = resource
	}

	handle() {
		let that = this;
		this.$notify({
			title: this.resource.title,
			dangerouslyUseHTMLString: true,
			message: this.resource.content,
			duration: 6000,
			onClick: function() {
				this.close();
				if (that.resource.type.includes("ASSISTANT_")) {
					let url = that.resource.actionUrl.split("?")[0];
					let payload = that.resource.actionUrl.split("?")[1];
					const waitApproval = store.getters["permission/getIframeMap"](url);
					router.push(waitApproval  + '?' + payload);
				}
			}
		});
		store.dispatch('notify/addMessage', this.resource);
	}
}

export default Notify
